import { WEB_HOOK_URL } from "../../../request"

export const webhookUrl = () => {
    return WEB_HOOK_URL
}